import { createFileRoute, Navigate, Outlet, redirect } from '@tanstack/react-router';
import DashboardLayout from '@/layouts/dashboard-layout/dashboard-layout';
import { useAuthStore } from '@/stores/auth-store';

export const Route = createFileRoute('/(dashboard)/_dashboard')({
  component: RouteComponent,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState();
    if (!isAuthenticated()) {
      return redirect({ to: '/login' });
    }
  },
});

function RouteComponent() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}
